import React from 'react';

import config from '../config/index.json';
import { Divider } from './Divider';

const MapComp = () => {
  const { maps } = config;
  const { title, phone } = maps;

  return (
    <section className={`py-8`} id="maps">
      <div className={`container max-w-5xl mx-auto m-8`}>
        <h1
          className={`w-full my-2 text-5xl font-bold leading-tight text-center text-primary`}
        >
          {title.split(' ').map((word, index) => (
            <span
              key={index}
              className={index % 2 ? 'text-primary' : 'text-border'}
            >
              {word}{' '}
            </span>
          ))}
        </h1>
        <Divider />
        <div className={`flex flex-wrap flex-col-reverse sm:flex-row`}>
          <div className={`w-full sm:w-1/2 p-6 mt-6`}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d268.8463233476263!2d77.37561968071344!3d28.674764795407498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb9d6a259c75%3A0xa7c21d51a97129ca!2sAutomax%20Automotives!5e0!3m2!1sen!2sin!4v1764581244148!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps"
            ></iframe>
          </div>
          <div className={`w-full sm:w-1/2 p-6 mt-6`}>
            <div className={`align-middle`}>
              <h3
                className={`text-3xl text-primary font-bold leading-none mb-3`}
              >
                Automax Automotives
              </h3>
              <p className={`text-gray-800 mb-8`}>
                45, Street Number 4, Rajinder Nagar Industrial Area, Rajendra
                Nagar, Ghaziabad, Uttar Pradesh 201005
              </p>
              {phone && (
                <p className={`text-gray-800 mb-6`}>
                  <span className="font-semibold">Phone: </span>
                  <a href={`tel:${phone}`} className="text-primary hover:underline">
                    {phone}
                  </a>
                </p>
              )}
              <a
                href="https://maps.app.goo.gl/Ce45rTJ6QVfPX2gM7"
                target="_blank"
                rel="noreferrer"
                className="inline-block bg-primary text-white font-bold py-2 px-4 rounded hover:bg-orange-600 transition-colors"
              >
                View on Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { MapComp };
